import React, { Component } from 'react';
import { Route } from 'react-router';
import { Layout } from './components/Layout';
import { Home } from './components/Home';
import { registrationForm } from './components/RegistrationForm';
import { UnsubscribeForm } from './components/UnsubscribeForm';
import { DeclineForm } from './components/DeclineForm';
import { EventExpired } from './components/EventExpired';
import { EventFlyer } from './components/EventFlyer';
import { SystemMaintenence } from './components/SystemMaintenence';

import './custom.css'

export default class App extends Component {
    static displayName = App.name;

   
  render () {
    return (
      <Layout>
        <Route exact path='/' component={Home} />
        <Route path='/regform/:eid/:gid' component={registrationForm} />
        <Route path='/unsub/:id' component={UnsubscribeForm} />
        <Route path='/decform/:id' component={DeclineForm} />
        <Route path='/regexp' component={EventExpired} />
        <Route path='/flyer/:id' component={EventFlyer} />
        <Route path='/maintenence' component={SystemMaintenence} />
      </Layout>
    );
  }
}
